const buttons = document.querySelectorAll("#categories button")

for (const btn of buttons) {
    btn.onclick = () => {
        for (const j of buttons) {
            j.classList.remove("active")
            document.querySelector(`section.${j.innerHTML.toLowerCase()}`).classList.remove("active")
        }
        btn.classList.add("active")
        document.querySelector(`section.${btn.innerHTML.toLowerCase()}`).classList.add("active")
    }
}
